export const SET_IS_VD_ABOVE_ATC_RENDERED = 'app/SET_IS_VD_ABOVE_ATC_RENDERED';
export const SET_IS_PA_ABOVE_ATC_RENDERED = 'app/SET_IS_PA_ABOVE_ATC_RENDERED';
